
function Contacts() {
  return (
    <div>Контакты</div>
  );
}

export default Contacts;